export const round2 = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  // Avoid binary floating artifacts (e.g., 59.99999999999999)
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

export const format2 = (value) => round2(value).toFixed(2);

